import React from 'react'
import { toast } from 'react-hot-toast';
import { HiCheck, HiExclamation, HiX, HiFire } from 'react-icons/hi';

function getAlertSymbol(symbol) {
    
    if (symbol === "success") {
        return (
            <div className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-green-100 text-green-500">
                <HiCheck className="h-8 w-8"/>
            </div>
        )

    } else if (symbol === "danger") {
        return (
            <div className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-red-100 text-red-500">
                <HiX className="h-8 w-8"/>
            </div>
        )

    } else if (symbol === "warning") {
        return (
            <div className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-orange-100 text-orange-500">
                <HiExclamation className="h-8 w-8"/>
            </div>
        )

    } else {
        return (
            <div className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-blue-100 text-blue-500">
                <HiFire className="h-8 w-8"/>
            </div>
        )
    }
}

const AlertBox = (alertType, message) => toast.custom((t) => (
    <div className={`${t.visible ? 'animate-enter' : 'animate-leave'} 
            max-w-md w-72 md:w-96 bg-white shadow-lg rounded-lg pointer-events-auto flex flex-row ring-1 ring-black ring-opacity-5 duration-100`}>

        <div className="flex-1 w-full p-4 items-center">
            <div className="flex items-start">

                {getAlertSymbol(alertType)}

                <div className="ml-3 flex-1">
                    <p className="text-sm md:text-base font-medium text-gray-900 text-center"> 
                    {message}
                    </p>
                </div>

            </div>

        </div>

    </div>
  ))


export default AlertBox